import { api } from "@/lib/api";

const PREFIX = "hotelos.cache.";
const MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24h

export function readCache(key) {
    try {
        const raw = localStorage.getItem(PREFIX + key);
        if (!raw) return null;
        const { ts, data } = JSON.parse(raw);
        if (!ts || Date.now() - ts > MAX_AGE_MS) return null;
        return data;
    } catch {
        return null;
    }
}

export function writeCache(key, data) {
    try {
        localStorage.setItem(PREFIX + key, JSON.stringify({ ts: Date.now(), data }));
    } catch {
        // ignore quota
    }
}

export function clearCache(prefix = "") {
    Object.keys(localStorage)
        .filter((k) => k.startsWith(PREFIX + prefix))
        .forEach((k) => localStorage.removeItem(k));
}

/**
 * Get JSON via api.get(path) with localStorage fallback when the network fails.
 * Returns: { data, source: 'network'|'cache'|null, error: Error|null }
 */
export async function getCached(path, params = undefined) {
    const key = params ? `${path}?${new URLSearchParams(params).toString()}` : path;
    try {
        const r = await api.get(path, params ? { params } : undefined);
        writeCache(key, r.data);
        return { data: r.data, source: "network", error: null };
    } catch (err) {
        const cached = readCache(key);
        if (cached) return { data: cached, source: "cache", error: err };
        return { data: null, source: null, error: err };
    }
}
